
import { ClientsContainer } from "@/components/admin/clients/ClientsContainer";
import { ClientSearch } from "@/components/dashboard/ClientSearch";
import { SearchResult } from "@/types/client-search";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { Spinner } from "@/components/ui/spinner";
import AdminLayout from "@/components/layout/AdminLayout";

const ClientsPage = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { toast } = useToast();

  useEffect(() => {
    const checkAccess = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        
        if (!session) {
          navigate("/auth");
          return;
        }

        // Check if user is admin OR producer
        const { data: roleData, error } = await supabase
          .from('user_roles')
          .select('role')
          .eq('user_id', session.user.id)
          .in('role', ['admin', 'producer'])
          .single();

        if (error || !roleData) {
          toast({
            variant: "destructive",
            title: "Access Denied",
            description: "You don't have permission to access this page.",
          });
          navigate("/dashboard");
          return;
        }
        
        setLoading(false);
      } catch (error) {
        console.error("Error checking access:", error);
        toast({
          variant: "destructive",
          title: "Error",
          description: "An unexpected error occurred. Please try again.",
        });
        navigate("/dashboard");
      }
    };

    checkAccess();
  }, [navigate, toast]);

  const handleClientSelect = (client: SearchResult) => {
    console.log("Selected client:", client);
    navigate(`/admin/contact/${client.id}`);
  };

  if (loading) {
    return (
      <AdminLayout>
        <div className="flex justify-center items-center min-h-screen">
          <Spinner size="lg" />
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout title="Clients">
      <div className="bg-white/50 backdrop-blur-sm border border-primary/10 rounded-xl p-6 shadow-sm mb-8">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
          <div>
            <p className="text-neutral mt-1">
              Manage and view all client information
            </p>
          </div>
          <div className="w-full md:w-1/3">
            <ClientSearch onClientSelect={handleClientSelect} />
          </div>
        </div>
        <div className="bg-white/80 rounded-lg border border-primary/5 shadow-sm">
          <ClientsContainer />
        </div>
      </div>
    </AdminLayout>
  );
};

export default ClientsPage;
